
      var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLoader = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 148,
  height: 148,
  viewBox: "0 0 148 148",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 73.539,
  cy: 73.539,
  r: 49.5,
  transform: "rotate(45 73.54 73.54)",
  stroke: "var(--theme-bright, #E2CFF7)",
  strokeWidth: 5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M55.54 27.593c7.053-2.707 14.69-3.703 22.296-2.909 7.606.795 14.97 3.359 21.502 7.486a50.904 50.904 0 0 1 16.11 16.28c4.06 6.576 6.551 13.972 7.272 21.592",
  stroke: "var(--theme-primary, #9631ff)",
  strokeWidth: 6
})));

      const __svgRaw = "<svg width=\"148\" height=\"148\" viewBox=\"0 0 148 148\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<circle cx=\"73.5391\" cy=\"73.5391\" r=\"49.5\" transform=\"rotate(45 73.5391 73.5391)\" stroke=\"var(--theme-bright, #E2CFF7)\" stroke-width=\"5\"/>\r\n<path d=\"M55.5393 27.5934C62.5933 24.8859 70.2296 23.8896 77.8357 24.6845C85.4419 25.4793 92.8061 28.043 99.3379 32.1701C105.87 36.2972 111.387 41.8728 115.448 48.4496C119.508 55.0265 121.999 62.4216 122.72 70.0418\" stroke=\"var(--theme-primary, #9631ff)\" stroke-width=\"6\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/loader.df561012a7bbf03963844975459f2c1b.svg"),
        {
          React: SvgLoader,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      